import { createFileRoute, Outlet } from "@tanstack/react-router"
import { z } from "zod"

import { ScheduleActionsProvider } from "../hooks/use-schedule-actions"

export const Route = createFileRoute("/settings/schedules")({
  validateSearch: z.object({
    filter: z.enum(["all", "failing", "paused"]).optional().catch("all"),
    q: z.string().optional().catch(""),
  }),
  component: () => (
    <ScheduleActionsProvider>
      <Outlet />
    </ScheduleActionsProvider>
  ),
})
